<template>
  <section>
    <div class="container">
      <div class="row justify-content-center justify-content-md-between">
        <div class="col-auto px-0">
          <mdb-btn flat dark-waves icon="arrow-left" type="button" title="Regresar" @click="$router.go(-1)">
            Regresar
          </mdb-btn>
        </div>
      </div>
      <div class="encabezado-detalles">
        <header class="h4-responsive text-center pt-3">Reporte</header>
        <div class="row mx-0 mt-2">
          <div class="col-12 col-md-4">
            <span class="small-block font-titulo">Nombre del reporte</span>
            <p>
              Clientes nuevos
            </p>
          </div>
          <div class="col-12">
            <span class="small-block font-titulo">Descripción</span>
            <p class="mb-1">
              Reporte de clientes registrados durante el período seleccionado. Se toma como cliente a los que realizaron al menos un pedido.
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-4">
          <mdb-input v-model="fechaAno" type="number" label="Año" class="my-2" outline :min="2000" :max="2030" />
        </div>
      </div>
    </div>
    <div v-if="cargando" class="mensaje-no-items py-3">
      <LoaderKel />
      <p class="texto mt-2">
        Cargando
      </p>
    </div>
    <!-- Mensaje cuando el vendedor seleccionado no tiene pedido -->
    <div v-else-if="!data.length" class="mensaje-no-items pb-3">
      <font-awesome-icon icon="clipboard-list" size="5x" class="icono" />
      <p class="texto">No hay reportes según los parámetros seleccionados</p>
    </div>
    <div class="container" v-else>
      <div class="table-container">
        <div class="table-wrapper">
          <table>
            <thead>
              <th>
                <div class="ancho-2">
                  vendedores
                </div>
              </th>
              <th>
                <div>
                  Enero
                </div>
              </th>
              <th>
                <div>
                  Febrero
                </div>
              </th>
              <th>
                <div>
                  Marzo
                </div>
              </th>
              <th>
                <div>
                  Abril
                </div>
              </th>
              <th>
                <div>
                  Mayo
                </div>
              </th>
              <th>
                <div>
                  Junio
                </div>
              </th>
              <th>
                <div>
                  Julio
                </div>
              </th>
              <th>
                <div>
                  Agosto
                </div>
              </th>
              <th>
                <div>
                  Septiembre
                </div>
              </th>
              <th>
                <div>
                  Octubre
                </div>
              </th>
              <th>
                <div>
                  Noviembre
                </div>
              </th>
              <th>
                <div>
                  Diciembre
                </div>
              </th>
              <th>
                <div>
                  Total
                </div>
              </th>
            </thead>
            <tbody>
              <tr v-for="(p, i) in data" :key="i" :class="{ 'fila-totales': p.zona === 'TOTALES' }">
                <td data-columna="Vendedores">
                  <div>
                    <p class="">
                      {{ p.zona }}
                    </p>
                  </div>
                </td>
                <td data-columna="Enero">
                  <div class="">
                    <p>{{ p.enero }}</p>
                  </div>
                </td>
                <td data-columna="Febrero">
                  <div class="">
                    <p>{{ p.febrero }}</p>
                  </div>
                </td>
                <td data-columna="Marzo">
                  <div class="">
                    <p>{{ p.marzo }}</p>
                  </div>
                </td>
                <td data-columna="Abril">
                  <p>
                    {{ p.abril }}
                  </p>
                </td>
                <td data-columna="Mayo">
                  <div class="">
                    <p>{{ p.mayo }}</p>
                  </div>
                </td>
                <td data-columna="Junio">
                  <p>
                    {{ p.junio }}
                  </p>
                </td>
                <td data-columna="Julio">
                  <p>
                    {{ p.julio }}
                  </p>
                </td>
                <td data-columna="Agosto">
                  <p>
                    {{ p.agosto }}
                  </p>
                </td>
                <td data-columna="Septiembre">
                  <p>
                    {{ p.septiembre }}
                  </p>
                </td>
                <td data-columna="Octubre">
                  <p>
                    {{ p.octubre }}
                  </p>
                </td>
                <td data-columna="Noviembre">
                  <p>
                    {{ p.noviembre }}
                  </p>
                </td>
                <td data-columna="Diciembre">
                  <p>
                    {{ p.diciembre }}
                  </p>
                </td>
                <td data-columna="Total">
                  <p>
                    {{ p.total }}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>

    </div>

    <AlertaMensaje :alerta-mensaje="alertaMensaje" @cerrar="alertaMensaje.contenido = ''" />
  </section>
</template>

<script>
import { mdbInput, mdbBtn } from 'mdbvue'
// import FiltrosTipo1 from '@/components/FiltrosTipo1.vue'
import AlertaMensaje from '@/components/AlertaMensaje.vue'
import LoaderKel from '@/components/LoaderKel.vue'
import { apiPost } from '@/funciones/api.js'
import { convertirNumeroAFixed } from '@/funciones/funciones.js'
export default {
  name: 'Actividades',
  components: {
    mdbInput,
    mdbBtn,
    // FiltrosTipo1,
    AlertaMensaje,
    LoaderKel
  },
  data () {
    return {
      cargando: false,
      responsive: { vendedor: 'col-12', btnRestablecer: 'col-12 col-md-auto' },
      fechaAno: (new Date().getFullYear()).toString(),
      alertaMensaje: { contenido: '' },
      restablecer: false,
      data: []
    }
  },
  mounted () {
    this.actualizar()
  },
  watch: {
    fechaAno () {
      this.actualizar()
    }
  },
  methods: {
    restablecerFiltros () {
      this.restablecer = true
      this.fechaAno = (new Date().getFullYear()).toString()
      this.actualizar()
    },
    actualizar () {
      this.cargando = true
      const data = this.fechaAno ? 'ver_ano=' + this.fechaAno.substring(0, 4) : ''
      apiPost({ s: 'nuevosClientesPorMes' }, data)
        .then((res) => {
          this.cargando = false
          if (res.data) {
            this.procesarDatos(res.data.nuevos_clientes)
          }
        }).catch(() => {
          this.alertaMensaje = {
            contenido: 'Ocurrió un error obteniendo los datos',
            tipo: 'error'
          }
        })
    },
    procesarDatos (datosBackend) {
      const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
      const datosProcesados = {}

      datosBackend.forEach(item => {
        const clave = item.nombre_vendedor
        const datosIniciales = {
          zona: clave,
          enero: 0,
          febrero: 0,
          marzo: 0,
          abril: 0,
          mayo: 0,
          junio: 0,
          julio: 0,
          agosto: 0,
          septiembre: 0,
          octubre: 0,
          noviembre: 0,
          diciembre: 0,
          total: 0
        }

        if (!datosProcesados[clave]) {
          datosProcesados[clave] = datosIniciales
        }

        if (item.meses && Array.isArray(item.meses)) {
          item.meses.forEach(mesData => {
            const mesNombre = meses[mesData.mes - 1]
            const nuevosClientes = mesData.nuevos_clientes || 0

            datosProcesados[clave][mesNombre] += nuevosClientes
            datosProcesados[clave].total += nuevosClientes
          })
        }
      })

      // Calcular totales por mes
      const totales = {
        zona: 'TOTALES',
        enero: 0,
        febrero: 0,
        marzo: 0,
        abril: 0,
        mayo: 0,
        junio: 0,
        julio: 0,
        agosto: 0,
        septiembre: 0,
        octubre: 0,
        noviembre: 0,
        diciembre: 0,
        total: 0
      }

      Object.values(datosProcesados).forEach(item => {
        totales.enero += item.enero
        totales.febrero += item.febrero
        totales.marzo += item.marzo
        totales.abril += item.abril
        totales.mayo += item.mayo
        totales.junio += item.junio
        totales.julio += item.julio
        totales.agosto += item.agosto
        totales.septiembre += item.septiembre
        totales.octubre += item.octubre
        totales.noviembre += item.noviembre
        totales.diciembre += item.diciembre
        totales.total += item.total
      })

      const datosConTotales = Object.values(datosProcesados)
      datosConTotales.push(totales)

      this.data = datosConTotales.sort((a, b) => {
        if (a.zona === 'TOTALES') return 1
        if (b.zona === 'TOTALES') return -1
        return a.zona.localeCompare(b.zona)
      })
    },
    convertirValorAFixed (numero) {
      return convertirNumeroAFixed(numero)
    },
    mesDelAño () {
      const meses = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ]
      return meses.join(', ')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 80dvw;
  margin: 0 auto;
  padding: 20px;
}

table {
  border-collapse: collapse;
  width: 100%;
}

thead {
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px #dddddd solid;
  background-color: #fafafa;
}

th {
  padding: .6rem .4rem .6rem .4rem;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  font-size: .7rem;
  text-transform: uppercase;
}

th:last-child {
  border-right: none;
}

td {
  padding: .3rem;
  padding-bottom: 0;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;
  font-size: .75rem;
}

tr:hover td {
  background-color: #f9f9f9;
}

// tr:nth-child(even) {
//   background-color: #f8f9fa;
// }

tr:nth-child(even):hover td {
  background-color: #f1f3f4;
}

.table-container {
  border: 1px solid #e7e6e6;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 30px;
}

.table-wrapper {
  overflow: auto;
  max-height: 80dvh;
}

.ancho-1 {
  width: 300px;
}

.ancho-2 {
  width: 200px;
}

.ancho-3 {
  width: 100px;
}

.table.actividades {
  // Define los breakpoints para el responsive de ul.table
  @include ul-table-responsive-at ("576px");
}

.tabla-container {
  overflow: auto;
}

.contenedor-tabla {
  max-width: 80dvw;
}

@media (max-width: 1020px) {
  .container {
    width: 100dvw;
    padding: 0px;
  }

  .table-wrapper {
    width: 100dvw;
  }
}

@media (max-width: 576px) {
  .table-wrapper {
    max-height: none;
    overflow-x: hidden;
  }

  table {
    width: 100%;
  }

  thead {
    display: none;
  }

  tr {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid black;
    width: 90%
  }

  td {
    display: flex;
    flex-wrap: nowrap;
    padding-top: .5rem !important;
    padding-bottom: 0rem !important;
    height: auto !important;
    border: none;
    width: 90% !important;
    min-width: 0;
  }

  td::before {
    content: attr(data-columna) "                          " attr(second-data-columna);
    white-space: pre-wrap;
    font-weight: 500;
    margin-right: .25rem;
    min-width: 105px;
    width: 105px !important;
    flex-shrink: 0;
  }

  td>div {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  td>div>p,
  td>div>span {
    word-break: break-word;
    overflow-wrap: break-word;
    min-width: 0;
  }
}

.fila-totales {
  background-color: #f0f4f8;
  border-top: 2px solid #dee2e6;
  font-weight: 600;
}

.fila-totales td {
  border-bottom: none;
  background-color: #f0f4f8;
}

.fila-totales p {
  font-weight: bold !important;
}
</style>
